var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"steam-btn",on:{"click":_vm.steamLogin}},[_c('img',{attrs:{"src":require("../../assets/images/mycard/sits_small.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }